import React from 'react';

import * as d3 from 'd3';

import SelectionTextBox from './SelectionTextBox.js';
import Filter from './Filter.js';
import './FilterWidget.css';

const STATES = {
    "alabama": "al",
    "alaska": "ak",
    "arizona": "az",
    "arkansas": "ar",
    "california": "ca",
    "colorado": "co",
    "connecticut": "ct",
    "delaware": "de",
    "district of columbia": "dc",
    "florida": "fl",
    "georgia": "ga",
    "hawaii": "hi",
    "idaho": "id",
    "illinois": "il",
    "indiana": "in",
    "iowa": "ia",
    "kansas": "ks",
    "kentucky": "ky",
    "louisiana": "la",
    "maine": "me",
    "maryland": "md",
    "massachusetts": "ma",
    "michigan": "mi",
    "minnesota": "mn",
    "mississippi": "ms",
    "missouri": "mo",
    "montana": "mt",
    "nebraska": "ne",
    "nevada": "nv",
    "new hampshire": "nh",
    "new jersey": "nj",
    "new mexico": "nm",
    "new york": "ny",
    "north carolina": "nc",
    "north dakota": "nd",
    "ohio": "oh",
    "oklahoma": "ok",
    "oregon": "or",
    "pennsylvania": "pa",
    "puerto rico": "pr",
    "rhode island": "ri",
    "south carolina": "sc",
    "south dakota": "sd",
    "tennessee": "tn",
    "texas": "tx",
    "utah": "ut",
    "vermont": "vt",
    "virginia": "va",
    "virgin islands": "vi",
    "washington": "wa",
    "west virginia": "wv",
    "wisconsin": "wi",
    "wyoming": "wy"
}

const VARIABLES = ['path-length', 'path-width', 'injuries', 'fatalities', 'state'];
const OPERATORS = ['>', '>=', '=', '<=', '<'];
const UNITS = ['mi', 'yds', '', '', ''];

class FilterWidget extends React.Component {
    constructor(props) {
        super(props);

        this.partitionClick = this.partitionClick.bind(this);
    }

    partitionClick(event) {
        const part = this.props['partitioner'];
        const clicked_part = event.target.childNodes[0].textContent;

        let toggled = this.props['filters']['partition'] !== undefined ? this.props['filters']['partition']['display'] : part.part_keys;
        if (toggled.includes(clicked_part)) {
            toggled = toggled.filter(el => el != clicked_part);
        }
        else {
            toggled.push(clicked_part);
        }

        // Should probably make this an actual Filter object at some point
        const filter = {'partition': {
            'func': tor => toggled.includes(part.partition_func(tor)),
            'display': toggled,
            'toHeaderString': () => part.to_string(toggled)
        }}

        this.props['onfilterchange'](filter);
    }

    stateParse(state_str) {
        if (Object.keys(STATES).includes(state_str.toLowerCase())) {
            return STATES[state_str.toLowerCase()].toUpperCase();
        }
        else if (Object.values(STATES).includes(state_str.toLowerCase())) {
            return state_str.toUpperCase();
        }

        return null;
    }

    filterSuggestions(entered_txt) {
        const parsed = Filter.getPossibilities(entered_txt);

        let suggestions;
        if (typeof parsed['vars'] === 'object') {
            suggestions = parsed['vars'];
        }
        else if (typeof parsed['ops'] === 'object') {
            suggestions = parsed['ops'];
        }
        else {
            suggestions = parsed['val'];
        }
        suggestions['autocomplete'] = parsed['autocomplete'];
        suggestions['maybe_complete'] = parsed['maybe_complete'];
        return suggestions;
    }

    filterParse(filter_str) {
        return Filter.fromString(filter_str);
    }

    filterSearch(filters) {
        let filter_obj = Object.fromEntries(Object.keys(this.props['filters'])
            .filter(f => f != 'partition')
            .map(f => [f, null]));

        filters.forEach(filt => {
            filter_obj[filt.variable] = filt;
        });

        this.props['onfilterchange'](filter_obj);
    }

    render() {
        const part = this.props['partitioner'];

        const toggled = this.props['filters']['partition'] !== undefined ? this.props['filters']['partition']['display'] : part.part_keys;

        const part_control_style = key => {
            const idx = part.part_keys.indexOf(key);
            const bg_color = toggled.includes(key) ? part.colors[idx] : '#ffffff';
            const text_color = d3.hsl(bg_color).l > 0.5 ? '#000000' : '#ffffff';
            return {'backgroundColor': bg_color, 'color': text_color};
        }

        const width = Math.min(800, (this.props['width'] - 450) * 0.9);
        const filters = Object.entries(this.props['filters']).filter(([k, v]) => k != 'partition').map(([k, v]) => v);

        return (
            <div id='filter-controls'>
                <div className='control'>
                    <ul id='partition-control'>
                        {part.name}:
                        {
                            part.part_keys.map(k => {
                                return <li key={k} style={part_control_style(k)} onClick={this.partitionClick}>{k}</li>
                            })
                        }
                    </ul>
                </div>
                <div className='control'>
                    Filters:&nbsp;
                    <SelectionTextBox
                        content={filters}
                        placeholder={'e.g., ' + this.props['example']}
                        onselectionupdate={this.filterSearch.bind(this)}
                        parser={this.filterParse.bind(this)}
                        width={width}
                        suggestion_callback={this.filterSuggestions.bind(this)}
                        max_selections={10}
                    />
                </div>
            </div>
        );
    }
}

export default FilterWidget;